export default __webpack_public_path__ + "818a8df3fc9de4ca4bafc6276ba68065.png";